import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { User } from '../models';
import { loginApi } from '../../config';


@Injectable()
export class UserService {

  constructor(
    readonly apiService: ApiService,
    readonly authService: AuthService
  ) {}

  setAuth(token: string): void {
    this.authService.setToken(token);
  }

  attemptAuth(): Observable<User> {
    return this.apiService.postForAuth(loginApi.attemptAuth).pipe(map(
      (data: any) => {
        const token = data.headers.get('SR-Authorization');
        this.setAuth(token);
        return data.body;
      }
    ));
  }

  checkTokenExpiry(): Observable<any> {
    return this.apiService.get(loginApi.checkTokenExpiry);
  }

  logout(): Observable<any> {
    return this.apiService.get(loginApi.logout);
  }

  getToken(body: object): Promise<any> {
    return this.apiService.postUrlEncoded(loginApi.tokenUrl, body);
  }

}
